/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */

export type QuizsetSearchReqPeriod = typeof QuizsetSearchReqPeriod[keyof typeof QuizsetSearchReqPeriod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuizsetSearchReqPeriod = {
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  ALL: 'ALL',
} as const;
